import memoize from 'lodash/memoize';
import { createSelector } from '@reduxjs/toolkit';
import type { NetworkRequest } from 'c-data-layer';
import { NetworkRequestState } from 'c-data-layer';
import type { CommonState } from 'c-types/RootState';

const getLargeLogosDictionary = (state: CommonState) => state.skin.uploadingLargeLogoById;
const getSmallLogosDictionary = (state: CommonState) => state.skin.uploadingSmallLogoById;
// fallbacks as persisted state from before these were added won't have them
const noRequests = {};
const getLargeDarkLogosDictionary = (state: CommonState) =>
    state.skin.uploadingLargeDarkLogoById ?? noRequests;
const getSmallDarkLogosDictionary = (state: CommonState) =>
    state.skin.uploadingSmallDarkLogoById ?? noRequests;

const getAttachingDictionary = (state: CommonState) => state.skin.attachingSkinById;

const idleState = { state: NetworkRequestState.Idle } as NetworkRequest;
export const getUploadingLargeLogoById = createSelector(getLargeLogosDictionary, uploading =>
    memoize((id: number) => uploading[id] ?? idleState),
);

export const getUploadingSmallLogoById = createSelector(getSmallLogosDictionary, uploading =>
    memoize((id: number) => uploading[id] ?? idleState),
);

export const getUploadingLargeDarkLogoById = createSelector(
    getLargeDarkLogosDictionary,
    uploading => memoize((id: number) => uploading[id] ?? idleState),
);

export const getUploadingSmallDarkLogoById = createSelector(
    getSmallDarkLogosDictionary,
    uploading => memoize((id: number) => uploading[id] ?? idleState),
);

export const getAttachingSkinById = createSelector(getAttachingDictionary, attaching =>
    memoize((id: number) => attaching[id] ?? idleState),
);
